import { render, staticRenderFns } from "./activities-results.vue?vue&type=template&id=fb42b36a&"
import script from "./activities-results.vue?vue&type=script&lang=js&"
export * from "./activities-results.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports